/**
 * NAT 그룹 관리 store
 *
 * @since 2018-08-06
 * @author kdydesign.kim
 */

import {SecutiryPolicyApiPrefix as objApiPrefix} from 'utils'

// NAT 그룹 데이터
const initNatGroupData = () => {
  return {
    name: void 0,
    desc: void 0
  }
}

export const state = () => ({
  natGroupList: [],
  natGroupData: initNatGroupData(),
  selectedNatGroupData: void 0
})

export const mutations = {
  // NAT 그룹 목록 조회
  getNatGroupList (state, data) {
    state.natGroupList = data
  },

  // NAT 그룹 추가
  saveNatGroupData (state, data) {
    state.natGroupList.push(data)
    state.natGroupData = initNatGroupData()
  },

  // NAT 그룹 조회
  getNatGroupData (state, data) {
    state.natGroupData = data
  },

  // NAT 그룹 수정
  updateNatGroup (state, data) {
    state.natGroupList = _.map(state.natGroupList, (o) => {
      if (o.nat_grp_id === data.nat_grp_id) {
        o = data
      }
      return o
    })
  },

  // NAT 그룹 삭제
  deleteNatGroup (state, groupId) {
    const itemIndex = _.findIndex(state.natGroupList, {nat_grp_id: groupId})

    state.natGroupList.splice(itemIndex, 1)
  },

  // NAT 그룹 선택 설정
  selectNatGroupData (state, data) {
    state.selectedNatGroupData = data
  },

  // NAT 그룹 데이터 초기화
  resetNatGroupData (state) {
    state.natGroupData = initNatGroupData()
  }
}

export const actions = {
  // NAT 그룹 목록 조회
  async getNatGroupList ({commit}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/groups`)

    if (code === 'ok') {
      commit('getNatGroupList', result)
    }
  },

  // NAT 그룹 추가
  async saveNatGroupData ({commit, state, dispatch}) {
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/nat/groups`, state.natGroupData)

    if (code === 'ok') {
      commit('saveNatGroupData', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // NAT 그룹 조회
  async getNatGroupData ({commit, state}) {
    const groupId = state.selectedNatGroupData.nat_grp_id
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/nat/groups/${groupId}`)

    if (code === 'ok') {
      commit('getNatGroupData', result)
    }
  },

  // NAT 그룹 수정
  async updateNatGroup ({commit, state, dispatch}) {
    const groupId = state.selectedNatGroupData.nat_grp_id
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/nat/groups/${groupId}`, state.natGroupData)

    if (code === 'ok') {
      commit('updateNatGroup', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },

  // NAT 그룹 삭제
  async deleteNatGroup ({commit, state, dispatch}) {
    const groupId = state.selectedNatGroupData.nat_grp_id
    const {code} = await this.$axios.$delete(`${objApiPrefix}/nat/groups/${groupId}`)

    if (code === 'ok') {
      commit('deleteNatGroup', groupId)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  }
}

export const getters = {
  // 그룹 목록
  selectTypeNatGroupList (state) {
    const natGroupList = state.natGroupList

    return _.map(natGroupList, (o) => {
      return {
        label: o.name,
        value: o.nat_grp_id
      }
    })
  }
}

export const strict = false
